import script from "./TagSpec8454.vue?vue&type=script&setup=true&lang=js"
export * from "./TagSpec8454.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__